module.exports = __webpack_public_path__ + "assets/img/logo-rakumart-europe.f40a59ac.svg";